import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _forEach from "lodash/forEach";
import _sortBy from "lodash/sortBy";
import _reverse from "lodash/reverse";
import _findIndex from "lodash/findIndex";
import _omit from "lodash/omit";
import _uniqBy from "lodash/uniqBy";
import _isEqual from "lodash/isEqual";
import _has from "lodash/has";
import _reject from "lodash/reject";
import _reduce from "lodash/reduce";
import _partition from "lodash/partition";
import _set from "lodash/set";
import _cloneDeep from "lodash/cloneDeep";
import _clone from "lodash/clone";
import _map from "lodash/map";
import _filter from "lodash/filter";
import _get from "lodash/get";
import _mapValues from "lodash/mapValues";
import _keys from "lodash/keys";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.filter.js";
import moment from 'moment/moment';
import { getTransactionsBulkStart, getTransactionsBulkEnd, getTransactionById, updateTransactionsViewList, getTransactions, resetTransactions, getTransactionsMonthRollup, getDailyTransactionsSummary, setTransactionsFilter, recategorizeMerchant, createTransactionTag, deleteTransactionTag, getTopMerchants, getCategoryWindowRollups, getMonthlyEstimatedIncome, getTransactionsMonthCashFlow, getTransactionsCashFlowMonthly, getTransactionsSpendingMonthly, getDailyTransactionsCashFlow, getDailyAverageTransactionsCashFlow, getCashFlowProjection, createMerchantCategoryRule, updateCategoryWindowRollups, updateTopMerchants, createTransaction, deleteTransaction, editTransaction } from "../../actions/yodlee";
import { yodlee as yodleeUtils } from "../../utils";
import { isUnauthenticateAction } from "../../utils/auth";
import { CashFlowCategories, DATE_FORMAT, TransactionCategoriesV2 } from "../../constants";
var SPENDING = CashFlowCategories.SPENDING,
    EARNING = CashFlowCategories.EARNING;

var createTransactionData = function createTransactionData() {
  return {
    transactions: [],
    monthRollups: {},
    lastPageReached: false,
    lastRequestCompleted: null,
    needsRefresh: false
  };
};

var createEmptyBuckets = function createEmptyBuckets() {
  return {
    all: undefined,
    category: {},
    tag: {},
    merchantName: {},
    accountId: {}
  };
};

var getInitialState = function getInitialState() {
  return {
    allTransactionsById: {},
    buckets: createEmptyBuckets(),
    categoryRollups: {},
    cashFlowRollups: {},
    topMerchants: {},
    categoryWindowRollups: {},
    dailyRollups: {},
    monthlyEstimates: {},
    resultsSetToken: undefined,
    transactionsOutdated: false,
    bulkLoadingInProgress: false,
    viewList: [],
    viewFilter: {}
  };
};
/**
 * Updates the redux state given transactionData and the desired filter.
 *
 * @param {Object} state The current transactions redux state
 * @param {Object} data A transactionData object
 * @param {Object} filter A filter for transaction data
 *
 * @return {Object} The new redux state
 * */


var updateStateWithTransactionData = function updateStateWithTransactionData(state, data, filter) {
  if (!filter || _keys(filter).length === 0) {
    return _objectSpread(_objectSpread({}, state), {}, {
      buckets: _objectSpread(_objectSpread({}, state.buckets), {}, {
        all: _objectSpread({}, data)
      })
    });
  }

  var key = _keys(filter)[0];

  var value = filter[key];

  if (!state.buckets[key]) {
    return state;
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    buckets: _objectSpread(_objectSpread({}, state.buckets), {}, _defineProperty({}, key, _objectSpread(_objectSpread({}, state.buckets[key]), {}, _defineProperty({}, value, _objectSpread({}, data)))))
  });
};

export var getAllTransactionsLocal = function getAllTransactionsLocal(state) {
  return Object.values(state.allTransactionsById);
};
/**
 * Helper method which runs a lodash operation across all transactions in all buckets and the all transactions list.
 *
 * @param {Object}   state     The current transactions redux state
 * @param {Function} operation The lodash function to run e.g.(_.map, _.filter); must be a pure function
 * @param {Function} func      The function body to supply to the lodash function
 * @param {Object}   filter    A filter object; empty object for the "all" bucket, undefined for all buckets
 *
 * @return {Object} A new state
 * */

var allTransactionsOperation = function allTransactionsOperation(state, operation, func, filter, operateOnAll) {
  var isUnfiltered = !filter || Object.keys(filter).length === 0;

  var buckets = _mapValues(state.buckets, function (value, key) {
    // Operate on the "all" bucket
    if (key === 'all') {
      var transactions = _get(value, 'transactions');

      if (transactions && (isUnfiltered || operateOnAll)) {
        return _objectSpread(_objectSpread({}, value), {}, {
          transactions: operation(transactions, func)
        });
      }

      return value;
    } // Operate on each bucket


    return _mapValues(value, function (v, k) {
      var transactions = _get(v, 'transactions');

      if (transactions && (!filter || filter[key] === k)) {
        return _objectSpread(_objectSpread({}, v), {}, {
          transactions: operation(transactions, func)
        });
      }

      return v;
    });
  }); // Operate on the allTransactionsById map as well for an unfiltered transaction operation


  if (isUnfiltered) {
    var updatedAllTransactions = operation(getAllTransactionsLocal(state), func);
    return _objectSpread(_objectSpread({}, state), {}, {
      allTransactionsById: updatedAllTransactions.reduce(function (acc, transaction) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, transaction.id, transaction));
      }, {}),
      buckets: buckets
    });
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    buckets: buckets
  });
};
/**
 * Helper method which runs a lodash operation across all transactions in all buckets and the all transactions list.
 *
 * @param {Object}   state           The current transactions redux state
 * @param {String}   transactionId   The buckets containing transaction given by transactionId that need to be marked
 *
 * @return {Object} A new state
 * */


var markNeedsRefreshForAllBucketsForTransaction = function markNeedsRefreshForAllBucketsForTransaction(state, transactionId) {
  var buckets = _mapValues(state.buckets, function (value, key) {
    // Operate on the "all" bucket
    if (key === 'all') {
      // Always mark the all bucket to needing refresh.
      // The transaction may have been modified from a filtered view without ever being in "all";
      // However, its date could have been moved up to now belong in the current "all" bucket.
      // Since we don't know in advance, it's safer to always mark this bucket.
      return _objectSpread(_objectSpread({}, value), {}, {
        needsRefresh: true
      });
    } // Operate on each bucket


    return _mapValues(value, function (v) {
      var _v$transactions;

      if (v !== null && v !== void 0 && (_v$transactions = v.transactions) !== null && _v$transactions !== void 0 && _v$transactions.find(function (transaction) {
        return transaction.id === transactionId;
      })) {
        return _objectSpread(_objectSpread({}, v), {}, {
          needsRefresh: true
        });
      }

      return v;
    });
  });

  return _objectSpread(_objectSpread({}, state), {}, {
    buckets: buckets
  });
};

var getOrCreateTransactionData = function getOrCreateTransactionData(state) {
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return yodleeUtils.getTransactionData(state, filter) || createTransactionData();
};

var removeTransactionsByFilter = function removeTransactionsByFilter(state, matchKey, matchValue, filter) {
  var operateOnAll = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return allTransactionsOperation(state, _filter, function (transaction) {
    return transaction[matchKey] !== matchValue;
  }, filter, operateOnAll);
};

var modifyTransactionsByFilter = function modifyTransactionsByFilter(state, matchKey, matchValue, modifyKey, modifyValue, filter) {
  return allTransactionsOperation(state, _map, function (transaction) {
    if (transaction[matchKey] !== matchValue) {
      return transaction;
    }

    var newTransaction = _clone(transaction);

    newTransaction[modifyKey] = modifyValue;
    return newTransaction;
  }, filter);
};

var reverseChronologicalSort = function reverseChronologicalSort(t1, t2) {
  // sort in descending order
  if (_get(t1, 'date') > _get(t2, 'date')) {
    return -1;
  }

  if (_get(t1, 'date') < _get(t2, 'date')) {
    return 1;
  }

  return 0;
};

var addTransactionsToBucket = function addTransactionsToBucket(bucket, transactions) {
  if (!transactions) {
    return bucket;
  }

  var destCategoryPrevTransactions = _get(bucket, 'transactions', []);

  var destCategoryTransactions = [].concat(_toConsumableArray(destCategoryPrevTransactions), _toConsumableArray(transactions));
  return _objectSpread(_objectSpread({}, bucket), {}, {
    transactions: destCategoryTransactions.sort(reverseChronologicalSort)
  });
};
/**
 * Add a new transaction to a bucket
 *
 * @param {Object} state - The full redux store (yes, really)
 * @param {string} bucket - The bucket we want the transaction to be in
 * @param {string} transaction - The transaction to be added
 *
 * @return {Object} The new `transactions` state with updated transaction and category buckets
 */


var addSingleTransactionToBucket = function addSingleTransactionToBucket(state, bucket, transaction) {
  var nextState = _cloneDeep(state); // Add transaction to destination bucket


  var destBucket = _get(nextState, "buckets.".concat(bucket));

  if (!destBucket) {
    return nextState;
  }

  var destNewBucket = addTransactionsToBucket(destBucket, [transaction]);
  nextState = _set(nextState, "buckets.".concat(bucket), destNewBucket);
  return nextState;
};

var addNeedsRefreshFlagToCategoryBucket = function addNeedsRefreshFlagToCategoryBucket(state, categoryName) {
  var nextState = _cloneDeep(state);

  var destCategoryBucket = _get(nextState, "buckets.category.".concat(categoryName));

  var destCategoryNewBucket = _objectSpread(_objectSpread({}, destCategoryBucket), {}, {
    needsRefresh: true
  });

  nextState = _set(nextState, "buckets.category.".concat(categoryName), destCategoryNewBucket);
  return nextState;
};

var addNeedsRefreshFlagToMerchantBucket = function addNeedsRefreshFlagToMerchantBucket(state, merchantName) {
  var nextState = _cloneDeep(state);

  var destMerchantBucket = _get(nextState, "buckets.merchantName.".concat(merchantName));

  if (!destMerchantBucket) {
    return nextState;
  }

  var destMerchantNewBucket = _objectSpread(_objectSpread({}, destMerchantBucket), {}, {
    needsRefresh: true
  });

  nextState = _set(nextState, "buckets.merchantName.".concat(merchantName), destMerchantNewBucket);
  return nextState;
};
/**
 * Updates the category for transactions that match canonicalMerchantName
 * (and have no category override).
 *
 * @param {Object} bucket
 * @param {string} transactionId
 * @param {string} canonicalMerchantName
 * @param {string} newCategory
 * @param {boolean} isRollback - Should be `true` for createMerchantCategoryRule.FAIL and
 *  `false` on `createMerchantCategoryRule.START`
 *
 * @return {Array} Bucket of transactions
 */


var getTransactionsWithNewCategoryForMerchantName = function getTransactionsWithNewCategoryForMerchantName(bucket, transactionId, canonicalMerchantName, newCategory, isRollback) {
  var shouldUpdateBucket = false;

  var newTransactions = _map(bucket.transactions, function (transaction) {
    if (yodleeUtils.shouldUpdateTransactionCategoryForMerchantName(transaction, transactionId, canonicalMerchantName)) {
      shouldUpdateBucket = true;
      var category = transaction.category,
          previousCategory = transaction.previousCategory,
          categoryOverride = transaction.category_override,
          previousCategoryOverride = transaction.previousCategoryOverride;

      if (isRollback) {
        return _objectSpread(_objectSpread({}, transaction), {}, {
          category: previousCategory,
          previousCategory: undefined,
          category_override: previousCategoryOverride,
          previousCategoryOverride: undefined
        });
      }

      return _objectSpread(_objectSpread({}, transaction), {}, {
        category: newCategory,
        previousCategory: category,
        category_override: null,
        // we know transaction.id == transactionId || categoryOverride is null at this point
        previousCategoryOverride: categoryOverride
      });
    }

    return transaction;
  });

  return shouldUpdateBucket ? _objectSpread(_objectSpread({}, bucket), {}, {
    transactions: newTransactions
  }) : bucket;
};
/**
 * Updates category buckets for a specified canonical merchant name.
 *
 * Moves transactions matching canonicalMerchantName (and no category override) from
 * previous category to new category bucket.
 *
 * Should be called on createMerchantCategoryRule.START.
 *
 * @param {Object} allCategoriesBucket
 * @param {string} transactionId
 * @param {string} canonicalMerchantName
 * @param {string} newCategory
 *
 * @return {Object}
 */


var getCategoryBucketsWithNewCategoryForMerchantName = function getCategoryBucketsWithNewCategoryForMerchantName(allCategoriesBucket, transactionId, canonicalMerchantName, newCategory) {
  var transactionsToRecategorize = [];

  var strippedBuckets = _mapValues(allCategoriesBucket, function (categoryBucket, categoryName) {
    if (categoryName === newCategory) {
      return categoryBucket;
    }

    var transactions = _get(categoryBucket, 'transactions', []);

    var transactionGroups = _partition(transactions, function (transaction) {
      return yodleeUtils.shouldUpdateTransactionCategoryForMerchantName(transaction, transactionId, canonicalMerchantName);
    }); // Partition each of the category buckets into two groups
    // 1) transactions that should be recategorized, 2) those that should not


    var _transactionGroups = _slicedToArray(transactionGroups, 2),
        transactionsToRemove = _transactionGroups[0],
        transactionsToKeep = _transactionGroups[1];

    if (transactionsToRemove) {
      transactionsToRecategorize = [].concat(_toConsumableArray(transactionsToRecategorize), _toConsumableArray(transactionsToRemove));
    }

    return _objectSpread(_objectSpread({}, categoryBucket), {}, {
      transactions: transactionsToKeep
    });
  }); // update category and add previousCategory flag to use in case rollback is needed


  transactionsToRecategorize = _map(transactionsToRecategorize, function (transaction) {
    return _objectSpread(_objectSpread({}, transaction), {}, {
      category: newCategory,
      previousCategory: transaction.category,
      category_override: null,
      // any recategorized transaction by merchant either matches transactionId or had category_override null to begin with
      previousCategoryOverride: transaction.category_override
    });
  }); // Add the transactions to the destination category

  var destCategoryBucket = _get(allCategoriesBucket, newCategory, createTransactionData());

  var destCategoryNewBucket = addTransactionsToBucket(destCategoryBucket, transactionsToRecategorize);
  return _objectSpread(_objectSpread({}, strippedBuckets), {}, _defineProperty({}, newCategory, destCategoryNewBucket));
};
/**
 * Rollback category buckets.
 *
 * Should only be called on createMerchantCategoryRule.FAIL.
 *
 * @param {Object} allCategoriesBucket
 * @param {string} categoryToRollback
 *
 * @return {Object}
 */


var rollbackCategoryBucketsForMerchantName = function rollbackCategoryBucketsForMerchantName(allCategoriesBucket, categoryToRollback) {
  var rollbackBucket = allCategoriesBucket[categoryToRollback];

  var rollbackTransactionsMap = _reduce(rollbackBucket.transactions, function (acc, transaction) {
    var previousCategory = transaction.previousCategory,
        previousCategoryOverride = transaction.previousCategoryOverride;
    var prevCategoryTransactions = acc[previousCategory] || [];

    var updatedTransaction = _objectSpread(_objectSpread({}, transaction), {}, {
      category: previousCategory,
      previousCategory: undefined,
      category_override: previousCategoryOverride,
      previousCategoryOverride: undefined
    });

    prevCategoryTransactions.push(updatedTransaction);
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, previousCategory, prevCategoryTransactions));
  }, {});

  return _mapValues(allCategoriesBucket, function (categoryBucket, categoryName) {
    var transactions = categoryBucket.transactions; // remove the transactions that were added to the rollback bucket

    if (categoryName === categoryToRollback) {
      var rollbackTransactions = _reject(transactions, function (transaction) {
        return !!transaction.previousCategory;
      });

      return _objectSpread(_objectSpread({}, categoryBucket), {}, {
        transactions: rollbackTransactions
      });
    } // add back the transactions that were removed from their original buckets


    return addTransactionsToBucket(categoryBucket, rollbackTransactionsMap[categoryName]);
  });
};
/**
 * Updates the spending/earning cash flow rollups for a given month.
 *
 * @param {Object} state
 * @param {Object} filter
 * @param {string} dayInTargetMonth
 * @param {number} spending
 * @param {number} earning
 *
 * @return {Object} State with updated cash flow rollups
 */


var updateTransactionsMonthCashFlow = function updateTransactionsMonthCashFlow(state, filter, dayInTargetMonth, spending, earning) {
  var bucket = getOrCreateTransactionData(state, filter);
  var firstDayInTargetMonth = moment(dayInTargetMonth).startOf('month').format(DATE_FORMAT.STANDARD);

  if (_has(filter, 'category')) {
    // We do not use this endpoint for category rollups, so don't make any changes here
    return state;
  }

  if (_isEqual(filter, {})) {
    var _firstDayInTargetMont;

    // Continue to store spending/earning in the "all" bucket for legacy purposes
    var newAllBucket = _objectSpread(_objectSpread({}, bucket), {}, {
      monthRollups: _objectSpread(_objectSpread({}, bucket.monthRollups), {}, _defineProperty({}, firstDayInTargetMonth, _objectSpread(_objectSpread({}, bucket.monthRollups[firstDayInTargetMonth]), {}, {
        sum: spending
      })))
    });

    var newState = state;
    newState = updateStateWithTransactionData(newState, newAllBucket, {}); // add spending and earning to the cashFlowRollups slice

    newState = _objectSpread(_objectSpread({}, newState), {}, {
      cashFlowRollups: _objectSpread(_objectSpread({}, newState.cashFlowRollups), {}, {
        monthly: _objectSpread(_objectSpread({}, _get(newState, 'cashFlowRollups.monthly')), {}, _defineProperty({}, firstDayInTargetMonth, (_firstDayInTargetMont = {}, _defineProperty(_firstDayInTargetMont, SPENDING, spending), _defineProperty(_firstDayInTargetMont, EARNING, earning), _firstDayInTargetMont)))
      })
    });
    return newState;
  } // Handle non-category filters (e.g. merchantName, accountId)


  var newBucket = _objectSpread(_objectSpread({}, bucket), {}, {
    monthRollups: _objectSpread(_objectSpread({}, bucket.monthRollups), {}, _defineProperty({}, firstDayInTargetMonth, _objectSpread(_objectSpread({}, bucket.monthRollups[firstDayInTargetMonth]), {}, {
      sum: spending
    })))
  });

  return updateStateWithTransactionData(state, newBucket, filter);
};

var getTopSpendingSlice = function getTopSpendingSlice(sliceData, sliceName, startDate, endDate) {
  switch (sliceName) {
    case 'monthly':
      return _reduce(sliceData, function (acc, _ref) {
        var topSums = _ref.top_sums,
            month = _ref.month;
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, month, topSums));
      }, {});

    case 'weekly':
      return _reduce(sliceData, function (acc, _ref2) {
        var topSums = _ref2.top_sums,
            week = _ref2.week;
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, week, topSums));
      }, {});

    case 'window':
      return _defineProperty({}, "".concat(startDate, "-").concat(endDate), sliceData);

    default:
      return null;
  }
};

var changeMerchantCategoryRule = function changeMerchantCategoryRule(state, transactionId, canonicalMerchantName, newCategory, isRollback) {
  var newBuckets = _mapValues(state.buckets, function (bucket, bucketName) {
    // update the category for transactions with the specified merchant name in place in the 'all' bucket
    if (bucketName === 'all') {
      return getTransactionsWithNewCategoryForMerchantName(bucket, transactionId, canonicalMerchantName, newCategory, isRollback);
    }

    if (bucketName === 'category') {
      return isRollback ? rollbackCategoryBucketsForMerchantName(bucket, newCategory) : getCategoryBucketsWithNewCategoryForMerchantName(bucket, transactionId, canonicalMerchantName, newCategory);
    } // update the category for transactions with the specified merchant name in place in any non-category bucket


    return _mapValues(bucket, function (value) {
      return getTransactionsWithNewCategoryForMerchantName(value, transactionId, canonicalMerchantName, newCategory, isRollback);
    });
  });

  return _objectSpread(_objectSpread({}, state), {}, {
    buckets: newBuckets
  });
};
/**
 * Returns an object representing the spending for each day in a month.
 *
 * @param {Object} spendingByDay - Shape is {[date]: float, ...}
 *
 * @return {Object} Shape is {[dayOfMonth]: float, ...}
 */


var getSpendingByDayOfMonth = function getSpendingByDayOfMonth(spendingByDay) {
  return _reduce(spendingByDay, function (acc, amount, date) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, moment(date).date(), amount));
  }, {});
};

var updateViewList = function updateViewList(state) {
  var _transactionData$tran, _transactionData$tran2, _transactionData$tran3;

  var transactionData = yodleeUtils.getTransactionData(state, state.viewFilter); // update the view list to reflect the latest state of transactions
  // so that the view for a transaction updates properly as part of the
  // transactions page

  return _objectSpread(_objectSpread({}, state), {}, {
    viewList: (_transactionData$tran = transactionData === null || transactionData === void 0 ? void 0 : (_transactionData$tran2 = transactionData.transactions) === null || _transactionData$tran2 === void 0 ? void 0 : _transactionData$tran2.slice(0, state.viewList.length || (transactionData === null || transactionData === void 0 ? void 0 : (_transactionData$tran3 = transactionData.transactions) === null || _transactionData$tran3 === void 0 ? void 0 : _transactionData$tran3.length))) !== null && _transactionData$tran !== void 0 ? _transactionData$tran : []
  });
};

var transactionReducer = function transactionReducer(state, action) {
  var type = action.type,
      payload = action.payload,
      meta = action.meta;

  if (isUnauthenticateAction(action)) {
    return getInitialState();
  }

  switch (type) {
    case getTransactionById.SUCCESS_TYPE:
      {
        var transaction = payload.transaction;
        return _objectSpread(_objectSpread({}, state), {}, {
          allTransactionsById: _objectSpread(_objectSpread({}, state.allTransactionsById), {}, _defineProperty({}, transaction.id, transaction))
        });
      }

    case createTransaction.SUCCESS_TYPE:
      {
        var category = meta.category,
            merchantName = meta.merchantName;
        var _transaction = payload;

        var nextState = _cloneDeep(state); // add the transaction to all views it belongs to


        nextState = addSingleTransactionToBucket(nextState, 'all', _transaction);
        nextState = addSingleTransactionToBucket(nextState, "category.".concat(category), _transaction);
        nextState = addSingleTransactionToBucket(nextState, "merchantName.".concat(merchantName), _transaction);
        return updateViewList(nextState);
      }

    case deleteTransaction.SUCCESS_TYPE:
      {
        var _transaction2 = payload;
        var transactionId = _transaction2.id,
            _category = _transaction2.category,
            _merchantName = _transaction2.canonical_merchant_name;

        var _nextState = _cloneDeep(state); // remove the transaction to all views it belongs to


        _nextState = removeTransactionsByFilter(_nextState, 'id', transactionId, {
          category: _category
        }, true);
        _nextState = removeTransactionsByFilter(_nextState, 'id', transactionId, {
          merchantName: _merchantName
        });
        return updateViewList(_nextState);
      }
    // These START_TYPE and consequent FAIL_TYPE actions are for the
    // one-tap recat screen's optimistic response, which only changes the category field.

    case editTransaction.START_TYPE:
      {
        var _category2 = meta.category,
            previousCategory = meta.previousCategory,
            _transactionId = meta.transactionId;

        var _nextState2 = _cloneDeep(state);

        if (_category2 !== previousCategory) {
          // update the transaction with new values in the store
          _nextState2 = allTransactionsOperation(_nextState2, _map, function (transaction) {
            return transaction.id === _transactionId ? _objectSpread(_objectSpread({}, transaction), {}, {
              category: _category2
            }) : transaction;
          }); // add flag to refresh the new category

          _nextState2 = addNeedsRefreshFlagToCategoryBucket(_nextState2, _category2); // remove the transaction from the old category

          _nextState2 = removeTransactionsByFilter(_nextState2, 'id', _transactionId, {
            category: previousCategory
          });
        }

        return updateViewList(_nextState2);
      }

    case editTransaction.FAIL_TYPE:
      {
        var _category3 = meta.category,
            _previousCategory = meta.previousCategory,
            _transactionId2 = meta.transactionId;

        var _nextState3 = _cloneDeep(state);

        if (_category3 !== _previousCategory) {
          // update the transaction with old values in the store
          _nextState3 = allTransactionsOperation(_nextState3, _map, function (transaction) {
            return transaction.id === _transactionId2 ? _objectSpread(_objectSpread({}, transaction), {}, {
              category: _previousCategory
            }) : transaction;
          }); // add flag to refresh the old category

          _nextState3 = addNeedsRefreshFlagToCategoryBucket(_nextState3, _previousCategory); // remove the transaction from the new category

          _nextState3 = removeTransactionsByFilter(_nextState3, 'id', _transactionId2, {
            category: _category3
          });
        }

        return updateViewList(_nextState3);
      }

    case editTransaction.SUCCESS_TYPE:
      {
        var newTransaction = action.payload;
        var _category4 = meta.category,
            date = meta.date,
            _merchantName2 = meta.merchantName,
            _previousCategory2 = meta.previousCategory,
            previousDate = meta.previousDate,
            previousMerchantName = meta.previousMerchantName,
            _transactionId3 = meta.transactionId;

        var _nextState4; // update the transaction with new values in the store


        _nextState4 = allTransactionsOperation(state, _map, function (transaction) {
          return transaction.id === _transactionId3 ? newTransaction : transaction;
        });

        if (_category4 !== _previousCategory2) {
          // add flag to refresh the new category
          _nextState4 = addNeedsRefreshFlagToCategoryBucket(_nextState4, _category4); // remove the transaction from the old category

          _nextState4 = removeTransactionsByFilter(_nextState4, 'id', _transactionId3, {
            category: _previousCategory2
          });
        }

        if (_merchantName2 !== previousMerchantName) {
          // add flag to refresh the new merchant view
          _nextState4 = addNeedsRefreshFlagToMerchantBucket(_nextState4, _merchantName2); // remove the transaction from the old merchant view

          _nextState4 = removeTransactionsByFilter(_nextState4, 'id', _transactionId3, {
            merchantName: previousMerchantName
          });
        } // change the position of the transaction in the view list if the date was modified


        if (date !== previousDate) {
          // Mark buckets that contain this transaction as needing refresh. However,
          // this only happens when the view is popped out and re-entered on Native.
          // To make the UX better, we also sort all existing transactions by date.
          //
          // KNOWN bug: Consider the scenario where the user changes the date of the transaction to 1 month ago,
          // but currently the bucket only has transactions for the last week. We would then erroneously
          // be showing the user all transactions from the last week with then the new date of the transaction
          // at the end, even if there are transactions that occur between them.
          // With the combination of sorting + marking the bucket as "dirty", if the user goes looking
          // for this transaction at the end of the list/different filter they'll end up refetching which will
          // move that one transaction in the right place.
          _nextState4 = markNeedsRefreshForAllBucketsForTransaction(_nextState4, _transactionId3);
          _nextState4 = allTransactionsOperation(_nextState4, function (transactions) {
            return transactions.sort(reverseChronologicalSort);
          });
        }

        return updateViewList(_nextState4);
      }

    case createMerchantCategoryRule.START_TYPE:
      {
        var _transactionId4 = meta.transactionId,
            _category5 = meta.category,
            canonicalMerchantName = meta.canonicalMerchantName;

        var _nextState5 = changeMerchantCategoryRule(state, _transactionId4, canonicalMerchantName, _category5, false);

        return updateViewList(_nextState5);
      }

    case createMerchantCategoryRule.FAIL_TYPE:
      {
        var _transactionId5 = meta.transactionId,
            _category6 = meta.category,
            _canonicalMerchantName = meta.canonicalMerchantName;

        var _nextState6 = changeMerchantCategoryRule(state, _transactionId5, _canonicalMerchantName, _category6, true);

        return updateViewList(_nextState6);
      }

    case createMerchantCategoryRule.SUCCESS_TYPE:
      {
        var newCategory = meta.category;
        return addNeedsRefreshFlagToCategoryBucket(state, newCategory);
      }

    case recategorizeMerchant.SUCCESS_TYPE:
      {
        var _category7 = meta.category,
            _merchantName3 = meta.merchantName;

        var _nextState7 = _cloneDeep(state); // Remove transactions from all category buckets


        _nextState7.buckets.category = _mapValues(state.buckets.category, function (data) {
          var newData = _clone(data);

          newData.transactions = _filter(data.transactions, function (transaction) {
            return transaction.merchant_name === _merchantName3;
          });
          return newData;
        }); // Delete the destination category bucket

        _nextState7 = updateStateWithTransactionData(_nextState7, createTransactionData(), {
          category: _category7
        }); // All other buckets, just change the category in place for these transactions

        _nextState7 = modifyTransactionsByFilter(_nextState7, 'merchant_name', _merchantName3, 'category', _category7);
        return _nextState7;
      }

    /**
     * Add a tag to a transaction.
     *
     * TODO: Add this transaction to a tag bucket.
     */

    case createTransactionTag.START_TYPE:
    case deleteTransactionTag.FAIL_TYPE:
      {
        var tag = meta.tag,
            _transactionId6 = meta.transactionId;

        var _nextState8 = allTransactionsOperation(state, _map, function (transaction) {
          return transaction.id === _transactionId6 ? yodleeUtils.addTagToTransaction(transaction, tag) : transaction;
        });

        return updateViewList(_nextState8);
      }

    /**
     * Remove a tag to a transaction.
     *
     * TODO: Remove this from the tag bucket.
     */

    case deleteTransactionTag.START_TYPE:
    case createTransactionTag.FAIL_TYPE:
      {
        var _tag = meta.tag,
            _transactionId7 = meta.transactionId;

        var _nextState9 = allTransactionsOperation(state, _map, function (transaction) {
          return transaction.id === _transactionId7 ? yodleeUtils.removeTagFromTransaction(transaction, _tag) : transaction;
        });

        return updateViewList(_nextState9);
      }

    case getTransactionsMonthRollup.SUCCESS_TYPE:
      {
        var bucket = getOrCreateTransactionData(state, meta.filter);

        var newBucket = _objectSpread(_objectSpread({}, bucket), {}, {
          monthRollups: _objectSpread(_objectSpread({}, bucket.monthRollups), {}, _defineProperty({}, meta.month, _objectSpread(_objectSpread({}, bucket.monthRollups[meta.month]), {}, _defineProperty({}, meta.baseType.toLowerCase(), payload.sum))))
        });

        var newState = updateStateWithTransactionData(state, newBucket, meta.filter || {});
        return _objectSpread({}, newState);
      }

    case getMonthlyEstimatedIncome.SUCCESS_TYPE:
      {
        var dayInTargetMonth = meta.dayInTargetMonth;
        var firstDayInTargetMonth = moment(dayInTargetMonth).startOf('month').format(DATE_FORMAT.STANDARD);
        return _objectSpread(_objectSpread({}, state), {}, {
          monthlyEstimates: _objectSpread(_objectSpread({}, state.monthlyEstimates), {}, _defineProperty({}, firstDayInTargetMonth, _objectSpread(_objectSpread({}, _get(state, "monthlyEstimates.".concat(firstDayInTargetMonth))), {}, {
            income: _get(payload, 'estimated_income')
          })))
        });
      }

    case resetTransactions.getType():
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          allTransactionsById: {},
          buckets: createEmptyBuckets(),
          transactionsOutdated: false,
          resultsSetToken: undefined
        });
      }

    case setTransactionsFilter.getType():
      {
        // Sanitize the viewFilter as we only support one or
        // no keys for now.
        var filter = payload.filter,
            transactionCategoryVersion = payload.transactionCategoryVersion;

        var sanitizedFilter = _clone(filter);

        while (_keys(sanitizedFilter).length > 1) {
          delete sanitizedFilter[_keys(sanitizedFilter)[0]];
        }

        var viewFilter = yodleeUtils.isValidTransactionsFilter(sanitizedFilter, transactionCategoryVersion) ? sanitizedFilter : {};
        return _objectSpread(_objectSpread({}, state), {}, {
          viewFilter: viewFilter,
          viewList: []
        });
      }

    case getTransactionsBulkStart.getType():
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          bulkLoadingInProgress: true
        });
      }

    case getTransactionsBulkEnd.getType():
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          bulkLoadingInProgress: false
        });
      }

    case updateTransactionsViewList.getType():
      {
        var _viewFilter = state.viewFilter;
        var transactionData = getOrCreateTransactionData(state, _viewFilter);
        var transactions = transactionData.transactions;
        var limit = action.payload.limit;
        return _objectSpread(_objectSpread({}, state), {}, {
          viewList: transactions.slice(0, limit || transactions.length)
        });
      }

    case getTransactions.SUCCESS_TYPE:
      {
        var _transactionData = getOrCreateTransactionData(state, meta.filter);

        var areTransactionsOutdated = meta.resultsSetToken && state.resultsSetToken && payload.transactions_refreshed;
        var isLastPageReached = payload.transactions.length < meta.limit; // Prevent weirdness with concurrent requests just to be safe

        if (_transactionData.lastRequestCompleted && meta.requestStartTime < _transactionData.lastRequestCompleted) {
          return state;
        } // Remove transactions that aren't POSTED or PENDING


        var filteredTransactions = _filter(payload.transactions, yodleeUtils.shouldStoreTransaction); // Merge category v1 and category v2 fields


        var mergedCategoryTransactions = _map(filteredTransactions, yodleeUtils.mergeTransactionCategory);

        var _transactions = meta.shouldReset ? mergedCategoryTransactions : // Manually added transactions may already be in the store before
        // we fetched all transactions so we need to remove duplicates just in case
        _uniqBy(_transactionData.transactions.concat(mergedCategoryTransactions), 'id');

        var newTransactionData = _objectSpread(_objectSpread({}, _transactionData), {}, {
          lastPageReached: isLastPageReached,
          transactions: _transactions,
          lastRequestCompleted: Date.now(),
          needsRefresh: false
        });

        var _newState = updateStateWithTransactionData(state, newTransactionData, meta.filter || {});

        return _objectSpread(_objectSpread({}, _newState), {}, {
          resultsSetToken: payload.results_set_token || state.results_set_token,
          transactionsOutdated: areTransactionsOutdated
        });
      }

    case getDailyTransactionsSummary.SUCCESS_TYPE:
      {
        var _objectSpread17;

        var baseType = meta.baseType,
            _dayInTargetMonth = meta.dayInTargetMonth;

        var _firstDayInTargetMonth = moment(_dayInTargetMonth).startOf('month').format(DATE_FORMAT.STANDARD);

        var firstDayInPreviousMonth = moment(_firstDayInTargetMonth).subtract(1, 'month').format(DATE_FORMAT.STANDARD);
        return _objectSpread(_objectSpread({}, state), {}, {
          dailyRollups: _objectSpread(_objectSpread({}, state.dailyRollups), {}, _defineProperty({}, baseType, _objectSpread(_objectSpread({}, _get(state.dailyRollups, 'baseType')), {}, (_objectSpread17 = {}, _defineProperty(_objectSpread17, _firstDayInTargetMonth, _get(payload, 'sums_for_target_month')), _defineProperty(_objectSpread17, firstDayInPreviousMonth, _get(payload, 'sums_for_previous_month')), _objectSpread17))))
        });
      }

    case getTopMerchants.SUCCESS_TYPE:
      {
        var endDate = meta.endDate,
            startDate = meta.startDate;
        var topMerchants = state.topMerchants;
        var sliceNames = Object.keys(payload);

        var newTopMerchants = _reduce(sliceNames, function (acc, sliceName) {
          var sliceData = _get(payload, sliceName);

          var oldSlice = _get(topMerchants, sliceName);

          var newSlice = getTopSpendingSlice(sliceData, sliceName, startDate, endDate);
          return newSlice ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, sliceName, _objectSpread(_objectSpread({}, oldSlice), newSlice))) : acc;
        }, topMerchants);

        return _objectSpread(_objectSpread({}, state), {}, {
          topMerchants: newTopMerchants
        });
      }

    case getCategoryWindowRollups.SUCCESS_TYPE:
      {
        var _endDate = meta.endDate,
            _startDate = meta.startDate,
            today = meta.today; // The payload only contains categories with spending data,
        // so we manually add any missing categories here.

        var baseCategoryRollups = _reduce(_omit(TransactionCategoriesV2, [TransactionCategoriesV2.TRANSFERS, TransactionCategoriesV2.INCOME]), function (acc, category) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, category, 0));
        }, {});

        var categoryRollups = _reduce(payload.window, function (acc, _ref4) {
          var amount = _ref4.sum_amount,
              category = _ref4.category_v2;
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, category, amount));
        }, baseCategoryRollups); // the range represents the whole month if:
        // 1) the start of the range is the first of the month
        // 2) the end of the range is the end of the month OR in the current month, it is today or later


        var isForWholeMonth = moment(_startDate).date() === 1 && (moment(_endDate).isSameOrAfter(moment(_endDate).endOf('month'), 'days') || moment(_endDate).isSameOrAfter(moment(today), 'days')); // if the range is for the whole month, update the "monthRollups" for the bucket

        var _newState2 = state;

        if (isForWholeMonth) {
          var _firstDayInTargetMonth2 = moment(_startDate).format(DATE_FORMAT.STANDARD);

          _newState2 = _reduce(categoryRollups, function (acc, categoryRollup, category) {
            var bucket = getOrCreateTransactionData(state, {
              category: category
            });

            var newBucket = _objectSpread(_objectSpread({}, bucket), {}, {
              monthRollups: _objectSpread(_objectSpread({}, bucket.monthRollups), {}, _defineProperty({}, _firstDayInTargetMonth2, _objectSpread(_objectSpread({}, bucket.monthRollups[_firstDayInTargetMonth2]), {}, {
                sum: categoryRollup
              })))
            });

            return updateStateWithTransactionData(acc, newBucket, {
              category: category
            });
          }, state);
        }

        return _objectSpread(_objectSpread({}, _newState2), {}, {
          categoryWindowRollups: _objectSpread(_objectSpread({}, state.categoryWindowRollups), {}, _defineProperty({}, "".concat(_startDate, "-").concat(_endDate), categoryRollups))
        });
      }

    case updateCategoryWindowRollups.getType():
      {
        var _category8 = payload.category,
            amount = payload.amount,
            _date = payload.date;

        if (!yodleeUtils.isSpendingTransactionCategory(_category8)) {
          return state;
        }

        var newCategoryWindowRollups = _reduce(state.categoryWindowRollups, function (acc, categoryRollups, windowKey) {
          var _yodleeUtils$getRollu = yodleeUtils.getRollupWindowDates(windowKey),
              startDate = _yodleeUtils$getRollu.startDate,
              endDate = _yodleeUtils$getRollu.endDate; // If date window contains `date`, add `amount` to category


          if (moment(_date).isBetween(startDate, endDate, 'day', '[]')) {
            return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, windowKey, _objectSpread(_objectSpread({}, categoryRollups), {}, _defineProperty({}, _category8, _get(categoryRollups, _category8, 0) + amount))));
          }

          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, windowKey, categoryRollups));
        }, {});

        return _objectSpread(_objectSpread({}, state), {}, {
          categoryWindowRollups: newCategoryWindowRollups
        });
      }

    case updateTopMerchants.getType():
      {
        var _amount = payload.amount,
            _canonicalMerchantName2 = payload.canonicalMerchantName,
            _date2 = payload.date;

        var _newTopMerchants = _reduce(state.topMerchants, function (acc, sliceData, sliceName) {
          // Note: `monthly` and `weekly` are not implemented since there is no use case right now.
          if (sliceName === 'window') {
            var newWindows = _reduce(sliceData, function (windowAcc, windowData, windowKey) {
              var newWindowData = _cloneDeep(windowData);

              var _yodleeUtils$getRollu2 = yodleeUtils.getRollupWindowDates(windowKey),
                  startDate = _yodleeUtils$getRollu2.startDate,
                  endDate = _yodleeUtils$getRollu2.endDate; // If `date` falls in the window, then update merchant in `topMerchants.window`


              if (moment(_date2).isBetween(startDate, endDate, 'day', '[]')) {
                var index = _findIndex(windowData, {
                  canonical_merchant_name: _canonicalMerchantName2
                });

                if (index === -1) {
                  // If merchant doesn't exist in the window, create it
                  newWindowData.push({
                    canonical_merchant_name: _canonicalMerchantName2,
                    sum_amount: _amount
                  });
                } else {
                  var newAmount = windowData[index].sum_amount + _amount;

                  if (newAmount === 0) {
                    // If the resulting amount is $0, remove merchant from the window
                    // (will be removed by _.filter below)
                    newWindowData[index] = null;
                  } else {
                    // Otherwise, add `amount` to merchant rollup
                    newWindowData[index] = _objectSpread(_objectSpread({}, windowData[index]), {}, {
                      canonical_merchant_name: _canonicalMerchantName2,
                      sum_amount: newAmount
                    });
                  }
                }
              }

              var sortedData = _reverse(_sortBy(newWindowData, 'sum_amount'));

              var filteredData = _filter(sortedData);

              return _objectSpread(_objectSpread({}, windowAcc), {}, _defineProperty({}, windowKey, filteredData));
            }, []);

            return _objectSpread(_objectSpread({}, acc), {}, {
              window: newWindows
            });
          }

          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, sliceName, sliceData));
        }, {});

        return _objectSpread(_objectSpread({}, state), {}, {
          topMerchants: _newTopMerchants
        });
      }

    case getTransactionsMonthCashFlow.SUCCESS_TYPE:
      {
        var spending = payload.spending,
            earning = payload.earning;
        var _filter2 = meta.filter,
            _dayInTargetMonth2 = meta.dayInTargetMonth;
        return updateTransactionsMonthCashFlow(state, _filter2, _dayInTargetMonth2, spending, earning);
      }

    case getTransactionsCashFlowMonthly.SUCCESS_TYPE:
      {
        var _filter3 = meta.filter;
        var _newState3 = state;

        _forEach(payload, function (monthCashFlow, dayInTargetMonth) {
          _newState3 = updateTransactionsMonthCashFlow(_newState3, _filter3, dayInTargetMonth, monthCashFlow[SPENDING], monthCashFlow[EARNING]);
        });

        return _newState3;
      }

    /**
     * For convenience, we store category rollups in both the "categoryRollups" reducer
     * and "monthRollups" for each category. Make sure to update both places.
     */

    case getTransactionsSpendingMonthly.SUCCESS_TYPE:
      {
        var _filter4 = meta.filter;
        var _category9 = _filter4.category; // Update the "monthRollups" for the bucket

        var _bucket = getOrCreateTransactionData(state, _filter4);

        var _newBucket = _reduce(payload, function (acc, amount, firstDayInMonth) {
          return _objectSpread(_objectSpread({}, acc), {}, {
            monthRollups: _objectSpread(_objectSpread({}, acc.monthRollups), {}, _defineProperty({}, firstDayInMonth, _objectSpread(_objectSpread({}, acc.monthRollups[firstDayInMonth]), {}, {
              // This endpoint ALWAYS returns "spending" (aka: debits minus credits),
              // so we have to negate the amount for income categories
              sum: yodleeUtils.isIncomeCategory(_category9) ? -amount : amount
            })))
          });
        }, _bucket);

        var _newState4 = updateStateWithTransactionData(state, _newBucket, _filter4); // Update the "categoryRollups" reducer


        var _categoryRollups = _has(_filter4, 'category') ? _reduce(payload, function (acc, amount, firstDayInMonth) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, firstDayInMonth, _objectSpread(_objectSpread({}, _get(acc, firstDayInMonth)), {}, _defineProperty({}, _category9, yodleeUtils.isIncomeCategory(_category9) ? -amount : amount))));
        }, state.categoryRollups) : state.categoryRollups;

        return _objectSpread(_objectSpread({}, _newState4), {}, {
          categoryRollups: _categoryRollups
        });
      }

    case getDailyTransactionsCashFlow.SUCCESS_TYPE:
      {
        var _objectSpread32;

        var _dayInTargetMonth3 = meta.dayInTargetMonth;

        var targetMonthSpending = _get(payload, 'spending_target_month');

        var previousMonthSpending = _get(payload, 'spending_prior_month');

        var targetMonthWindowKey = yodleeUtils.createMonthWindowKey(_dayInTargetMonth3);
        var previousMonthWindowKey = yodleeUtils.createMonthWindowKey(moment(_dayInTargetMonth3).subtract(1, 'month'));
        var targetMonthDailySpending = getSpendingByDayOfMonth(targetMonthSpending);
        var previousMonthDailySpending = getSpendingByDayOfMonth(previousMonthSpending);
        return _objectSpread(_objectSpread({}, state), {}, {
          dailyRollups: _objectSpread(_objectSpread({}, state.dailyRollups), {}, _defineProperty({}, SPENDING, _objectSpread(_objectSpread({}, state.dailyRollups.spending), {}, (_objectSpread32 = {}, _defineProperty(_objectSpread32, targetMonthWindowKey, targetMonthDailySpending), _defineProperty(_objectSpread32, previousMonthWindowKey, previousMonthDailySpending), _objectSpread32))))
        });
      }

    case getDailyAverageTransactionsCashFlow.SUCCESS_TYPE:
      {
        var dayInEndMonth = meta.dayInEndMonth,
            dayInStartMonth = meta.dayInStartMonth;

        var averageSpendingPerDay = _get(payload, 'average_spending_per_day');

        var windowKey = yodleeUtils.createWindowKey(dayInStartMonth, dayInEndMonth);
        return _objectSpread(_objectSpread({}, state), {}, {
          dailyRollups: _objectSpread(_objectSpread({}, state.dailyRollups), {}, _defineProperty({}, SPENDING, _objectSpread(_objectSpread({}, state.dailyRollups.spending), {}, _defineProperty({}, windowKey, averageSpendingPerDay))))
        });
      }

    case getCashFlowProjection.SUCCESS_TYPE:
      {
        var _objectSpread36;

        var _dayInTargetMonth4 = meta.dayInTargetMonth;

        var _firstDayInTargetMonth3 = moment(_dayInTargetMonth4).startOf('month').format(DATE_FORMAT.STANDARD);

        return _objectSpread(_objectSpread({}, state), {}, {
          monthlyEstimates: _objectSpread(_objectSpread({}, state.monthlyEstimates), {}, _defineProperty({}, _firstDayInTargetMonth3, _objectSpread(_objectSpread({}, _get(state, "monthlyEstimates.".concat(_firstDayInTargetMonth3))), {}, (_objectSpread36 = {}, _defineProperty(_objectSpread36, EARNING, _get(payload, 'projected_earning')), _defineProperty(_objectSpread36, SPENDING, _get(payload, 'projected_bill_spending')), _objectSpread36))))
        });
      }

    default:
      return state;
  }
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var newState = transactionReducer(state, action);

  if (state.buckets !== newState.buckets) {
    // Anytime an action could have changed one of the transactions we want to update
    // the all transactions map
    var nextTransactions = yodleeUtils.getAllTransactionsFromBuckets(newState.buckets);
    return _objectSpread(_objectSpread({}, newState), {}, {
      allTransactionsById: _objectSpread(_objectSpread({}, newState.allTransactionsById), nextTransactions.reduce(function (acc, transaction) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, transaction.id, transaction));
      }, {}))
    });
  }

  return newState;
});